import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add Raw Material
export const addRawMaterial = async (formData) => {
  console.log("Raw material form data ---- ", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}rawMaterial/api/v1/create`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "auth-token": token,
      }
    });
    console.log("raw materail response",response);
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete Raw Material API
// export const deleteRawMaterial = async (ROWID) => {
//   console.log({ ROWID });
//   const token = localStorage.getItem("authToken");
//   try {
//     const response = await axios.delete(`${baseUrl}rawMaterial/api/v1/delete/${ROWID}`, {
//       headers: {
//         "auth-token": token,
//       }
//     });
//     return response;
//   } catch (error) {
//     console.log("Error is - ", error);
//     throw error;
//   }
// };
// Delete Raw Material API - expects ids array in request body
export const deleteRawMaterial = async (ids) => {
  console.log("Deleting raw materials with ids:", ids);
  const token = localStorage.getItem("authToken");
  
  // Ensure ids is always an array
  const idsArray = Array.isArray(ids) ? ids : [ids];
  
  try {
    const response = await axios({
      method: 'DELETE',
      url: `${baseUrl}rawMaterial/api/v1/delete`,
      data: { ids: idsArray },
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      }
    });
    return response;
  } catch (error) {
    console.log("Error deleting raw materials:", error);
    throw error;
  }
};

// Update Raw Material
export const updateRawMaterial = async (ROWID, data) => {
  console.log({ data });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}rawMaterial/api/v1/update/${ROWID}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "auth-token": token,
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Total count
export const countRawMaterial = async (formData) => {
  console.log(formData, "count");
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}rawMaterial/api/v1/getCount`, {
      headers: {
        "auth-token": token,
      },
      params: formData
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Get Raw Material Detail By ID
export const getRawMaterialDetailById = async (id) => {
  // const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}rawMaterial/api/v1/get-by-id/${id}`, {
      // headers: {
      //   "auth-token": token,
      // }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete Vendor Items By ID (for update mode)
export const deleteVendorItemsById = async (ROWID, data) => {
  console.log({ data });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}rawMaterial/api/v1/deleteVendorsById/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const addRawMaterailinZohoBooks = async (Id, payload) => {
  console.log("RawMaterail Zoho form data payload ---- ", payload);
  try {
    const response = await axios.post(`${baseUrl}zohoBooks/api/v1/item/${Id}`, payload, {
      headers: {
        "Content-Type": "application/json"
      }
    },)
    console.log("RawMaterail zoho books resp",response);
    return response;
  } catch (error) {
    throw error
  }
}


